import { gql } from '@apollo/client';

export const USER_AVATAR_DETAILS_FRAGMENT = gql`
  fragment BaseUserAvatar on User {
    id
    avatarUrl
  }
`;
